const BasicInformationLayout = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/BasicInformationLayout')
const InformationEdit = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/InformationEdit')
const PostList = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/post/PostList')
const OrganizationList = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/organization/OrganizationList')
const EmployeeList = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/employee/EmployeeList')
const CSWorkOrder = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/employee/CSWorkOrder')
const CSWorkOrderDetail = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/employee/CSWorkOrderDetail')
const BannersPage = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/BannersPage')
const HotBannersPage = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/HotBannersPage')
const PageSetting = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/PageSetting')
const SuperBannersPage = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/SuperBannersPage')
const BrandArea = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/BrandArea')
const BasicInformationNav = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/BasicInformationNav')
const StoreAdd = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/StoreAdd')
const StoreEdit = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/StoreEdit')
const StoreDetail = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/StoreDetail')
const ServiceCategory = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/ServiceCategory')
const ServiceCategoryAdd = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/ServiceCategoryAdd')
const AuthorityMgr = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/AuthorityMgr')
const SetHomePage = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/SetHomePage')
const SetNavPage = () => import(/* webpackChunkName: "basicInformation" */'@/components/basicInformation/pageSetting/SetNavPage')

export default {
  // name: 'basicInformation',
  path: 'basicInformation',
  component: BasicInformationLayout,
  children: [{
    name: 'storeDetail',
    path: 'storeDetail',
    component: StoreDetail,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'storeAdd',
    path: 'storeAdd',
    component: StoreAdd,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'storeEdit',
    path: 'storeEdit',
    component: StoreEdit,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'serviceCategory',
    path: 'serviceCategory',
    component: ServiceCategory,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'serviceCategoryAdd',
    path: 'serviceCategoryAdd',
    component: ServiceCategoryAdd,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'basicInformationNav',
    path: 'basicInformationNav',
    component: BasicInformationNav,
    meta: {
      module: 'basicInformation',
      keppAlive: true,
    },
  }, {
    name: 'informationEdit',
    path: 'informationEdit',
    component: InformationEdit,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'organizationList',
    path: 'organizationList',
    component: OrganizationList,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'postList',
    path: 'postList',
    component: PostList,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'employeeList',
    path: 'employeeList',
    component: EmployeeList,
    meta: {
      module: 'basicInformation',
      keppAlive: true,
      isPreserve: false,
      isOutside: false,
    },
  }, {
    name: 'cSWorkOrder',
    path: 'cSWorkOrder',
    component: CSWorkOrder,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'cSWorkOrderDetail',
    path: 'cSWorkOrder/detail',
    component: CSWorkOrderDetail,
    meta: {
      module: 'basicInformation',
    },
  }, {
    name: 'authorityMgr',
    path: 'employeeList/authorityMgr',
    component: AuthorityMgr,
    meta: {
      module: 'basicInformation',
      isSlibing: true,
    },
  }, {
    name: 'pageSetting',
    path: 'pageSetting',
    component: PageSetting,
    children: [
      {
        name: 'setHomePage',
        path: 'setHomePage',
        component: SetHomePage,
        meta: {
          module: 'basicInformation',
        },
      }, {
        name: 'setNavPage',
        path: 'setNavPage',
        component: SetNavPage,
        meta: {
          module: 'basicInformation',
        },
      }, {
        name: 'bannersPage',
        path: 'bannersPage',
        component: BannersPage,
        meta: {
          module: 'basicInformation',
        },
      }, {
        name: 'hotBannersPage',
        path: 'hotBannersPage',
        component: HotBannersPage,
        meta: {
          module: 'basicInformation',
        },
      }, {
        name: 'superBannersPage',
        path: 'superBannersPage',
        component: SuperBannersPage,
        meta: {
          module: 'basicInformation',
        },
      }, {
        name: 'brandArea',
        path: 'brandArea',
        component: BrandArea,
        meta: {
          module: 'basicInformation',
        },
      }, {
        path: '/',
        redirect: { name: 'bannersPage' },
      },
    ],
    meta: {
      module: 'basicInformation',
    },
  }, {
    path: '/',
    redirect: { name: 'basicInformationNav' },
  }],
}



// WEBPACK FOOTER //
// ./src/router/basicInformation.js